<mat-form-field class="mm-mt-4 full-width" appearance="fill">
  <mat-label>Script Token</mat-label>
  <input matInput type="text" [formControl]="token" />
  @if (token) {
  <button matSuffix mat-icon-button aria-label="Clear" (click)="token.setValue('')">
    <mat-icon>close</mat-icon>
  </button>
  }
</mat-form-field>
